import React from 'react';
import NavLink from './components/NavLink';
import { CategoriesContainer } from './Categories.styles';

interface CategoriesProps {
  categories: Array<any>;
  ordinal?: number;
  parentCategory?: object;
  urlPrefix: string;
  languageCode: string;
}

const Categories: React.FC<CategoriesProps> = ({
  categories,
  ordinal = 1,
  parentCategory,
  urlPrefix,
  languageCode,
}) => {
  const categoryItems = categories.map((category) => ({
    category,
    className: category.children.length > 17 ? 'scrollindicator' : null,
  }));

  return (
    <React.Fragment>
      {categoryItems.map((categoryItem, index) => (
        <li key={index}>
          <NavLink
            category={categoryItem.category}
            ordinal={ordinal}
            parentCategory={parentCategory}
            urlPrefix={urlPrefix}
            languageCode={languageCode}
          />
          {categoryItem.category.children.length && ordinal < 3 ? (
            <ul className={`category category-level-${ordinal + 1}`}>
              <CategoriesContainer className={categoryItem.className}>
                <Categories
                  categories={categoryItem.category.children}
                  ordinal={ordinal + 1}
                  parentCategory={categoryItem.category}
                  urlPrefix={urlPrefix}
                  languageCode={languageCode}
                />
              </CategoriesContainer>
            </ul>
          ) : null}
        </li>
      ))}
    </React.Fragment>
  );
};

export default Categories;
